import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import 'swiper/css';
import 'swiper/css/pagination';
import useInView from '../../hooks/useInView';

export default function GalleryHomeSection() {
  // Animation apparition au scroll pour le titre géant
  const [refTitle, inViewTitle] = useInView();
  const [galleryImages, setGalleryImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const q = query(
          collection(db, 'galerie'),
          orderBy('dateAjout', 'desc'),
          limit(10)
        );
        const querySnapshot = await getDocs(q);
        const images = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setGalleryImages(images);
      } catch (error) {
        console.error("Erreur lors de la récupération des images de la galerie:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchImages();
  }, []);

  if (loading) return null; // Ou un squelette de chargement si préféré
  if (galleryImages.length === 0) return null; // Ne rien afficher si pas d'images

  return (
    <section className="w-full max-w-6xl mx-auto px-4 py-10 relative mt-24">
      {/* Titre background géant animé */}
      <div
        ref={refTitle}
        className={`absolute inset-x-0 -top-16 max-w-6xl mx-auto px-4 flex justify-center pointer-events-none select-none z-0 transition-all duration-700 ${inViewTitle ? 'animate-fadeUp' : 'opacity-0 translate-y-10'}`}
      >
        <span className="text-white text-7xl md:text-8xl font-extrabold opacity-20 leading-none whitespace-nowrap tracking-tight" style={{ letterSpacing: '-0.03em' }}>GALERIE</span>
      </div>
      {/* Titre normal (pour l'accessibilité, caché visuellement) */}
      <h2 className="sr-only">Galerie</h2>
      <div className="relative z-10">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={30}
          slidesPerView={1}
          breakpoints={{
            640: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          pagination={{
            clickable: true,
            el: '.swiper-pagination-gallery',
            type: 'progressbar',
          }}
          autoplay={{
            delay: 3500,
            disableOnInteraction: false,
          }}
          className="w-full"
        >
          {galleryImages.map((image, idx) => (
            <SwiperSlide key={image.id || idx}>
              <div className="bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col group hover:scale-[1.03] transition h-[400px] min-h-[400px] max-h-[400px]">
                <img
                  src={image.url}
                  alt={image.titre || `gallery-slide-${idx}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-6">
                  <h3 className="text-white font-bold text-lg">{image.titre}</h3>
                  {image.evenement && <p className="text-efafcYellow text-sm">{image.evenement}</p>}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Barre de progression personnalisée */}
        <div className="swiper-pagination-gallery custom-swiper-progressbar mt-8"></div>
        <div className="flex justify-center mt-8">
          <a
            href="/galerie"
            className="bg-[#FFE400] text-[#001B56] font-extrabold rounded-xl px-8 py-3 text-center hover:bg-[#BDFF00] transition text-lg shadow-lg"
          >
            Voir toute la galerie
          </a>
        </div>
      </div>
    </section>
  );
}